import React, { useState } from 'react';
import './ContactForm.css';

export default function ContactForm() {
  const [form, setForm] = useState({ name: '', company: '', email: '', phone: '', needs: '' });
  const [submitting, setSubmitting] = useState(false);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if(!needsValid){
      alert('Merci de préciser votre besoin (minimum 6 caractères).');
      return;
    }
    setSubmitting(true);
    try {
      const payload = { ...form, needs: form.needs.trim() };
      const base = process.env.REACT_APP_PUBLICATION_SERVICE || 'http://localhost:4300';
      const res = await fetch(base + '/contacts', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept':'application/json' },
        body: JSON.stringify(payload)
      });
      const json = await res.json().catch(()=>null);
      if(!res.ok || (json && json.success === false)){
        const msg = (json && json.error && json.error.message) || `HTTP ${res.status}`;
        throw new Error(msg);
      }
      alert('Merci — nous avons bien reçu votre demande.');
      setForm({ name: '', company: '', email: '', phone: '', needs: '' });
    } catch(err){
      alert('Erreur lors de l\'envoi: ' + (err.message || 'inconnue'));
    } finally {
      setSubmitting(false);
    }
  }

  const needsTrimmed = form.needs.trim();
  const needsValid = needsTrimmed.length >= 6; // minimal length
  return (
    <form className="contact-form" onSubmit={handleSubmit} aria-label="Formulaire de contact">
      <div className="row">
        <label>
          Nom
          <input name="name" value={form.name} onChange={handleChange} placeholder="Votre nom" required />
        </label>
        <label>
          Société
          <input name="company" value={form.company} onChange={handleChange} placeholder="Votre société" />
        </label>
      </div>

      <div className="row">
        <label>
          Email
          <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="adresse@exemple.com" required />
        </label>
        <label>
          Téléphone
          <input name="phone" value={form.phone} onChange={handleChange} placeholder="+225 00 00 00 00" />
        </label>
      </div>

      <label className="full">
        Besoin / Message *
        <textarea name="needs" value={form.needs} onChange={handleChange} placeholder="Expliquez brièvement votre besoin" rows={6} required aria-required="true" minLength={6}
          onInvalid={(e)=> e.target.setCustomValidity('Merci de préciser votre besoin (minimum 6 caractères).')}
          onInput={(e)=> e.target.setCustomValidity('')}
        />
        {!needsValid && form.needs.length > 0 && (
          <div style={{fontSize:12, color:'#b45309', marginTop:4}}>Merci de détailler un peu plus (minimum 6 caractères).</div>
        )}
      </label>

      <div className="actions">
        <button type="submit" className="btn-primary" disabled={submitting || !needsValid}>
          {submitting ? 'Envoi...' : 'Envoyer la demande'}
        </button>
      </div>
    </form>
  );
}
